// selectors
import { getActiveScriptType } from 'current/selectors';

// requesters
import { requestTrialPlacements } from 'trial-placements/requesters';

// actions
import { setShowConfirmModal } from 'experiment';

const determineTitleTextMessageKey = ({ state, stepNumber }) => {
  const scriptType = getActiveScriptType(state);

  const scriptDescription = scriptType ? `-${scriptType}` : '';
  return `title-text__create${scriptDescription}-script--step-${stepNumber}`;
};

export const onEnterExperimentPlan = (dispatch, getState) => {
  const state = getState();

  return { titleTextMessageKey: determineTitleTextMessageKey({ state, stepNumber: 1 }) };
};

export const onSelectTrialPlacementOptions = (dispatch, getState) => {

  dispatch(requestTrialPlacements());

  const state = getState();
  return { titleTextMessageKey: determineTitleTextMessageKey({ state, stepNumber: 2 }) };
};

export const onEnterProductApplicationRate = (dispatch, getState) => {
  const state = getState();
  return { titleTextMessageKey: determineTitleTextMessageKey({ state, stepNumber: 3 }) };
};

export const onFinishFlow = (dispatch) => {
  dispatch(setShowConfirmModal(true));
};
